import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../../../../lib/utils';
import { cardClass } from '../../../../../styling/stylingHelper';
import { MultiSelectFilter } from '../../../../ui/MultiSelectFilter';
import { FilterBlock as FilterBlockType } from '../../../../../services/admin/cloudAgentTypes';

/**
 * filter → MultiSelectFilter (GENUI-4). An interactive food/drinks toggle. Selecting a value
 * fires `onFilterChange`, which the page turns into a server re-hydration (no LLM call) that
 * re-scopes the OTHER blocks by side. Rendered read-only (no callback) while streaming.
 */
export const FilterBlock: React.FC<{
  block: FilterBlockType;
  onFilterChange?: (block: FilterBlockType, selected: string[]) => void;
  disabled?: boolean;
}> = ({ block, onFilterChange, disabled }) => {
  const { t } = useTranslation();
  const options = block.options && block.options.length > 0 ? block.options : ['food', 'drinks'];
  // No explicit selection ⇒ everything selected (= unscoped / "all").
  const selected = block.selected ?? options;
  const optionObjects = options.map((o) => ({
    id: o,
    name: t(`overallType.${o}`, { defaultValue: o }),
  }));

  return (
    <div className={cn(cardClass, 'p-4')}>
      <MultiSelectFilter
        label={block.text}
        selectedValues={selected}
        availableOptions={optionObjects}
        onValuesChange={(values) => {
          if (!disabled) onFilterChange?.(block, values);
        }}
      />
    </div>
  );
};
